import { render } from "./PatientManagement.vue?vue&type=template&id=cb2a70aa&scoped=true"
import script from "./PatientManagement.vue?vue&type=script&lang=js"
export * from "./PatientManagement.vue?vue&type=script&lang=js"

import "./PatientManagement.vue?vue&type=style&index=0&id=cb2a70aa&lang=css"
import "./PatientManagement.vue?vue&type=style&index=1&id=cb2a70aa&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2a70aa"]])

export default __exports__